import { Info, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PRICING, WA_MESSAGES, wa, track } from "../../data/site";

export const Pricing = () => (
  <section id="precos" className="relative overflow-hidden bg-mist py-20 lg:py-28" data-testid="pricing-section">
    <div
      className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-aqua-100/60 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="02"
        eyebrow="Preços"
        title="Preços transparentes"
        subtitle="Consulte os nossos preços de referência e peça o seu orçamento gratuito."
      />

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {PRICING.map((group, i) => (
          <Reveal key={group.id} delay={(i % 3) * 0.08}>
            <div
              data-testid={`pricing-group-${group.id}`}
              className="h-full rounded-3xl border border-white bg-white p-6 shadow-[0_4px_24px_rgba(11,25,44,0.05)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(0,102,255,0.1)]"
            >
              <div className="flex items-center gap-3">
                <span className="grid h-11 w-11 place-items-center rounded-2xl bg-mist">
                  <group.icon className="h-5 w-5 text-brand" />
                </span>
                <h3 className="text-lg font-bold tracking-tight text-navy">{group.title}</h3>
              </div>
              <ul className="mt-5 divide-y divide-dashed divide-slate-100">
                {group.items.map(([label, price]) => (
                  <li key={label} className="flex items-baseline justify-between gap-4 py-3">
                    <span className="text-sm text-slate-500">{label}</span>
                    <span className="font-heading text-base font-extrabold text-navy">{price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mx-auto mt-10 max-w-3xl">
        <p className="flex items-start gap-3 rounded-2xl border border-aqua/20 bg-white/70 p-5 text-sm leading-relaxed text-slate-500 backdrop-blur" data-testid="pricing-note">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-aqua" />
          Os valores apresentados são preços de referência. O orçamento final poderá variar de
          acordo com o tamanho, estado e características do serviço.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-8 text-center">
        <a
          href={wa(WA_MESSAGES.precos)}
          target="_blank"
          rel="noopener noreferrer"
          id="cta-precos"
          data-testid="cta-precos-whatsapp"
          data-event="quote_request"
          onClick={() => track("quote_request", { location: "pricing" })}
          className="cta-whatsapp cta-orcamento inline-flex items-center gap-2.5 rounded-full bg-brand px-8 py-4 text-base font-semibold text-white shadow-xl shadow-brand/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-600 hover:shadow-2xl hover:shadow-brand/35"
        >
          <MessageCircle className="h-5 w-5" />
          Solicitar orçamento gratuito
        </a>
      </Reveal>
    </div>
  </section>
);
